export const generateJobInterviewQns = (
  systemPrompt,
  jobDescription,
  no = 5,
  isFormatInstruction = true,
  existingQnsConfig = null
) => {
  let systemPromptSet = systemPrompt;

  // Input for the request
  let input = {
    job_description: jobDescription,
    no: `${no}`,
  };

  if (existingQnsConfig && existingQnsConfig?.setExistingQns) {
    if (
      existingQnsConfig?.existingInterviewQns &&
      existingQnsConfig?.existingInterviewQns.length > 0
    ) {
      input[existingQnsConfig?.field] = generateInterviewQuestionString(
        existingQnsConfig?.existingInterviewQns
      );
    } else if (
      existingQnsConfig?.field &&
      existingQnsConfig?.existingInterviewQns.length === 0
    ) {
      input[existingQnsConfig?.field] = "";
    }
    systemPromptSet = addPlaceHolder(
      systemPromptSet,
      "existing_interview_questions",
      "Existing Interview Questions:"
    );
  }

  return {
    input,
    model: "gpt-4o-mini",
    max_error_allowed: 2,
    system_prompt: isFormatInstruction
      ? addFormatInstructions(systemPromptSet)
      : systemPrompt,
    is_structured_output: true,
    structure_output_config: [
      {
        name: "interviewQuestions",
        type: "List[str]",
        defaultValue: "",
        description:
          "A list of unique and relevant interview questions for the job description.",
        nestedConfig: [],
      },
    ],
  };
};

export function parseHtmlToText(htmlString) {
  // Use DOMParser to parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // Extract the text content of the parsed document
  return doc.body.textContent || "";
}

const addFormatInstructions = (systemPrompt) => {
  if (!systemPrompt.includes("{format_instructions}")) {
    systemPrompt += "\n{format_instructions}";
  }
  return systemPrompt;
};

const generateInterviewQuestionString = (interviewQuestions) => {
  if (!interviewQuestions) return "";
  if (interviewQuestions.length === 0) return "";
  let questionString = "";
  interviewQuestions.forEach((question, index) => {
    questionString += `${index + 1}. ${question.question}\n`;
  });
  return questionString;
};

const addPlaceHolder = (systemPrompt, placeHolderName, prefix = "") => {
  if (!systemPrompt.includes(`{${placeHolderName}}`)) {
    if (prefix === "") {
      systemPrompt += `\n{${placeHolderName}}`;
    } else {
      systemPrompt += `\n${prefix}\n{${placeHolderName}}`;
    }
  }
  return systemPrompt;
};
